/**
 * Report this fan, from the profile's actions sheet (ISSUE-1375). A thin
 * wrapper over the shared `ReportAccountDialog`, which files the same
 * `POST /account/report` the pool member menu and mobile already use.
 *
 * Like `FanActionsDialog`, it reads the fan's name from the cached profile
 * query keyed on the URL's `accountId`, so a reload with `?sheet=fan-report`
 * still names who is being reported. Until the name is known nothing mounts:
 * a report sheet that cannot say who it is about is never shown.
 */
import { useProfileGetForAccount } from "@sportsmet/profile-sdk/private";
import type { ReactNode } from "react";

import { ReportAccountDialog } from "../messageModeration/ReportAccountDialog";

export type typeFanReportDialogProps = {
  /** Driven by ?sheet=fan-report, never by component state. */
  open: boolean;
  onClose: () => void;
  accountId: string;
};

export const FanReportDialog = (props: typeFanReportDialogProps): ReactNode => {
  const profileQuery = useProfileGetForAccount(
    { accountId: props.accountId },
    { enabled: props.open && props.accountId !== "" },
  );
  const displayName = profileQuery.data?.data?.profile?.displayName ?? "";
  if (!props.open || displayName === "") return null;

  return (
    <ReportAccountDialog
      key={props.accountId}
      open
      onClose={props.onClose}
      reportedAccountId={props.accountId}
      displayName={displayName}
      chatId={null}
    />
  );
};
